<template>
  <div class="preview_wrap">
    <CommonHead title="自助预检"></CommonHead>
    <div class="content">
      <div v-if="questions.length > 0" class="form-box">
        <div class="" v-for="(item, index) in questions" :key="index">
          <RadioForm :question="item" :index="index + 1" @change="radioFormChange" />
        </div>
      </div>
      <van-empty v-else image="error" description="暂无问题" />

      <button @click="onSaveInspection">保存</button>

    </div>

  </div>
</template>
<script>
import CommonHead from "components/CommonHead";
import RadioForm from "components/RadioForm";
import {getAppQuestonList,saveAppInspection} from "api/register";
import { Toast,Dialog } from 'vant'
export default {
  name:'Preview',
  components: {
    CommonHead,RadioForm
  },
  data() {
    return {
      questions: [
        {
          optionType: 'single',
          question: '有无癫痫病、神经系统疾病及惊厥史 ？',
          options:['否','是'],
        },
        {
          optionType: 'input',
          question: '当前体温(℃):',
        }
      ],
      processId: '', // 流程id


    }

  },
  created() {
    this.processId = this.$route.query.processId;
    this.getQuestionList();
  },
  methods: {
    radioFormChange(value) {
      for (const i in this.questions) {
        if (this.questions[i].id === value.id) {
          this.questions[i].answer = value.answer
          break
        }
      }
    },
    onSaveInspection() {
      let that = this;
      for (let i = 0; i < this.questions.length; i++) {
        if (!this.questions[i].answer) {
          return Toast('请完整填写表单')
        }
        if (this.questions[i].answer === '是' || (this.questions[i].optionType == 'input' && (this.questions[i].answer < 36 || this.questions[i].answer > 37.3))) {
          return Dialog.alert({
            message: '自检结果不满足接种条件，请前往咨询台咨询'
          }).then(() => {
            this.$router.back()
          })
        }
      }
      const result = this.questions.map(item => {
        return { question: item.question, answer: item.answer }
      })
      saveAppInspection({
        inspectionList: result,
        processId: this.processId
      }).then(res => {
        if (res.code === 0) {
          Toast(res.message)
          setTimeout(() => {
            this.$router.go(-1);
          }, 500)
        }
      })

    },
    getQuestionList() {
      getAppQuestonList({
        processId: this.processId
      }).then(res => {
        if (res.code == 0) {
          res.data.forEach(item => {
            if (item.options) {
              item.options = item.options.split(",")
            }
          })
          this.questions = res.data;
        }
      })
    }

  }

}
</script>
<style lang="less" scoped>
.content {
  padding: 0px 14px;
  .form-box {
    padding-bottom: 120px;
    font-size: 16px;
    font-weight:300;
    line-height: 40px;
    color: #494a53;
    & > div:nth-child(odd){
      margin: 15px 0;
    }
  }
}
button {
  position: fixed;
  bottom: 50px;
  left: 0;
  right: 0;
  width: 90%;
  height: 45px;
  background-color: #50A0FF;
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 50px;
  border: 0;
  margin: 0 auto;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
}

</style>